// SPDX-License-Identifier: AGPL-3.0-or-later

const APOSTROPHE = "['\u2019]";

const YOU_INSULT_NOUN =
	'(?:idiot|asshole|jerk|moron|bastard|bitch|dick|cunt|dumbass|loser|freak|creep|weirdo|psycho|monster|trash|garbage|waste|clown|joke|liar|coward|snake|nerd|child|baby|brat|scum|shit|crap)';

const YOU_ARE_NOUN = `(?:an? )?${YOU_INSULT_NOUN}|a piece of (?:shit|crap)`;
const YOU_ARE_ADJ =
	'(?:stupid|dumb|the worst|awful|horrible|annoying|useless|trash|pathetic|worthless|disgusting|insufferable|unbearable|ridiculous|unhinged|delusional|crazy|insane|toxic|gross|vile|full of (?:shit|it)|dead(?: to me)?)';

/**
 * Person-directed insults only (second-person / at-you idioms).
 * Bare venting (shit, wtf, this sucks, I hate it) and third-person digs stay curious.
 */
const SALTY_LANGUAGE = new RegExp(
	String.raw`\b(?:` +
		[
			// Imperatives / idioms aimed at the addressee
			'stfu',
			'gtfo',
			'fuck you',
			'fuck(?: right)? off',
			'fuck yourself',
			'go fuck yourself',
			'screw you',
			'piss off',
			'drop dead',
			'eat shit',
			'eat a dick',
			'suck (?:my |a )?(?:dick|ass|balls|it)',
			'kiss my ass',
			'bite me',
			'shove it',
			'shut(?: the (?:fuck|hell))? up',
			`don${APOSTROPHE}t talk to me`,
			'get out of (?:here|my face)',
			'get lost',
			'go away',
			'stop talking',
			'leave me alone',
			'nobody likes you',
			'nobody asked(?: you)?',
			'no one likes you',
			'thanks for nothing',
			// Affect / hope aimed at "you"
			'hate you',
			'i hate(?:\\s+you)',
			`i can${APOSTROPHE}t stand(?:\\s+you)`,
			`i don${APOSTROPHE}t (?:like|care about) you`,
			`i(?:${APOSTROPHE}m| am)? (?:done|sick) (?:with|of) you`,
			'i hope you (?:die|rot|suffer|choke)',
			// "you …" / "you're …"
			'you suck',
			`you(?:${APOSTROPHE}re| are)(?: so| such)? (?:${YOU_ARE_NOUN}|${YOU_ARE_ADJ})`,
			`you (?:fucking |little |absolute |complete |total )*(?:a |an )?${YOU_INSULT_NOUN}`,
			'you piece of (?:shit|crap)',
			`you (?:can )?fuck(?: right)? off`,
			'you (?:make me sick|disgust me)',
			`you (?:don${APOSTROPHE}t|do not) (?:deserve|matter)`,
			'you (?:smell|stink)',
			'you (?:look|sound) (?:stupid|dumb|pathetic|ugly)',
			'you (?:ruin(?:ed)?|destroyed) (?:everything|it|this)',
			`what(?:${APOSTROPHE}s| is| the (?:fuck|hell) is) wrong with you`,
			'you can go to hell',
			'you (?:can )?(?:rot|burn) in hell',
		].join('|') +
		String.raw`)\b`,
	'iu',
);

export function matchesComposerCatSaltyLanguage(text: string): boolean {
	SALTY_LANGUAGE.lastIndex = 0;
	return SALTY_LANGUAGE.test(text);
}
